const data = {
  'designation-roles.dashboard.title': 'Designation Roles',
  'designation-roles.filter.designation.label': 'Designation Name',
  'designation-roles.filter.submit.buttontext': 'Search',
  'designation-roles.filter.clear.buttontext': 'Clear',
}
export default data
